import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, SearchIcon, TagIcon, CalendarIcon, UserIcon, ArrowRightIcon, ChevronRightIcon, BookIcon, MapPinIcon, ExternalLinkIcon } from 'lucide-react';
const Blog = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('all');
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    // Simulate API loading
    const timer = setTimeout(() => {
      setArticles([{
        id: '1',
        title: 'Top 5 Running Clubs for Beginners in Nairobi',
        excerpt: "Looking to start running but don, t, know, where, to, begin, These, five, running, communities, welcome, beginners, with: open, arms, and, structured, programs, : ., ',: category, 'communities",
        author: 'Jane Mwangi',
        date: 'May 15, 2023',
        image: '',
        featured: true
      }, {
        id: '2',
        title: 'How to Make the Most of a Tech Meetup',
        excerpt: 'Tech meetups are more than just presentations. Learn how to network effectively, ask the right questions, and follow up with new connections.',
        category: 'career',
        author: 'David Ochieng',
        date: 'June 2, 2023',
        image: '',
        featured: true
      }, {
        id: '3',
        title: 'The Rise of Community-Based Tourism in Kenya',
        excerpt: 'Discover how local communities are creating authentic tourism experiences that benefit both visitors and residents.',
        category: 'travel',
        author: 'Lucy Wambui',
        date: 'July 12, 2023',
        image: '',
        featured: false
      }, {
        id: '4',
        title: 'Essential Tips for First-Time Event Organizers',
        excerpt: 'Planning your first event? Here are the key considerations to ensure it runs smoothly and meets your objectives.',
        category: 'events',
        author: 'Michael Kimani',
        date: 'August 5, 2023',
        image: '',
        featured: false
      }, {
        id: '5',
        title: "Kenya, s, Emerging, Tech, Ecosystem: What, You, Need, to, Know, ',: excerpt, 'From fintech to agritech, Kenya': s, technology, sector, is, booming, : .Learn, about, the, key, players, trends, and, opportunities, : ., ',: category, 'technology",
        author: 'Sarah Njeri',
        date: 'August 23, 2023',
        image: '',
        featured: false
      }, {
        id: '6',
        title: 'Building a Successful Community: Lessons from JoinToday Partners',
        excerpt: 'Insights and best practices from community leaders who have built thriving groups on the JoinToday platform.',
        category: 'communities',
        author: 'John Maina',
        date: 'September 10, 2023',
        image: '',
        featured: false
      }, {
        id: '7',
        title: 'Book Clubs in Kenya: A Growing Literary Movement',
        excerpt: 'Explore the vibrant world of book clubs in Kenya, from community-based reading groups to online literary communities that are fostering a love for reading across the country.',
        category: 'communities',
        author: 'Wanjiku Mwangi',
        date: 'October 5, 2023',
        image: '',
        featured: true
      }, {
        id: '8',
        title: 'Guide to Bookshops in Nairobi: Where to Find Your Next Read',
        excerpt: 'Discover the best bookshops in Nairobi, from major retailers to specialty stores offering everything from educational materials to rare African literature.',
        category: 'lifestyle',
        author: 'James Omondi',
        date: 'November 12, 2023',
        image: '',
        featured: false
      }]);
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  const categories = [{
    id: 'all',
    name: 'All Articles'
  }, {
    id: 'communities',
    name: 'Communities'
  }, {
    id: 'events',
    name: 'Events'
  }, {
    id: 'career',
    name: 'Career'
  }, {
    id: 'technology',
    name: 'Technology'
  }, {
    id: 'travel',
    name: 'Travel'
  }, {
    id: 'lifestyle',
    name: 'Lifestyle'
  }];
  const filteredArticles = activeCategory === 'all' ? articles : articles.filter(article => article.category === activeCategory);
  const featuredArticles = articles.filter(article => article.featured);
  // Bookshops in Nairobi data
  const bookshops = [{
    name: 'Half Priced Books',
    description: 'A popular bookstore focusing on selling books at discounted prices, offering a budget-friendly option for readers.',
    location: 'Various locations in Nairobi',
    website: 'https://www.halfpricedbooks.co.ke'
  }, {
    name: 'Textbook Centre',
    description: 'Founded in 1964, it is a major book retailer and supplier with numerous branches across Nairobi and a wide selection of educational and general reading materials.',
    location: 'Multiple branches including Sarit Centre, Junction Mall, and Garden City',
    website: 'https://www.textbookcentre.com'
  }, {
    name: 'Prestige Bookshop',
    description: 'A well-known bookstore with a strong reputation for its extensive collection and often provides books not easily found elsewhere in the region.',
    location: 'Mama Ngina Street, Nairobi CBD',
    website: 'https://www.prestigebookshop.com'
  }, {
    name: 'Bookstop Limited',
    description: 'A premier bookshop with a large inventory of books for all ages and interests.',
    location: 'Yaya Centre, Hurlingham',
    website: 'https://www.bookstop.co.ke'
  }, {
    name: 'Savanis Book Centre',
    description: 'A long-standing bookseller and stationer, providing a variety of affordable school, commercial, and technical books.',
    location: 'Loita Street, Nairobi CBD',
    website: '#'
  }, {
    name: 'Kibangabooks',
    description: 'This bookshop specializes in a wide range of books by Kenyan and African authors, with a focus on the African continent.',
    location: 'Nairobi',
    website: 'https://www.kibangabooks.com'
  }, {
    name: 'Laxmi Book Sellers',
    description: 'Located at Crossroads, this is another book retailer in the city.',
    location: 'Crossroads, Nairobi',
    website: '#'
  }, {
    name: 'Bookpoint',
    description: 'A bookshop situated on Moi Avenue.',
    location: 'Moi Avenue, Nairobi CBD',
    website: '#'
  }, {
    name: 'Chyeni Bookshop',
    description: 'A bookshop found in Nairobi.',
    location: 'Nairobi',
    website: '#'
  }, {
    name: 'Keswick Books and Gifts',
    description: 'Another bookstore that caters to readers in Nairobi.',
    location: 'Nairobi',
    website: '#'
  }];
  return <div className="pb-16" data-id="element-770">
      <div className="border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800" data-id="element-771">
        <div className="max-w-4xl mx-auto p-4" data-id="element-772">
          <h1 className="text-2xl font-bold mb-2 flex items-center" data-id="element-773">
            <BookOpenIcon className="w-6 h-6 mr-2" data-id="element-774" />
            JoinToday Blog
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-775">
            Insights, guides, and stories from the Kenyan community
          </p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto p-4" data-id="element-776">
        {/* Search */}
        <div className="mb-8" data-id="element-777">
          <div className="relative" data-id="element-778">
            <input type="text" placeholder="Search articles..." className="w-full p-3 pl-10 border border-gray-300 dark:border-gray-600 rounded-lg" data-id="element-779" />
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" data-id="element-780" />
          </div>
        </div>
        {/* Featured Articles */}
        {featuredArticles.length > 0 && <div className="mb-8" data-id="element-781">
            <h2 className="text-xl font-bold mb-4" data-id="element-782">Featured Articles</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-783">
              {featuredArticles.map(article => <div key={article.id} className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden" data-id="element-784">
                  <div className="h-40 bg-gray-200 dark:bg-gray-700 border-b border-gray-300 dark:border-gray-600 relative" data-id="element-785">
                    <div className="absolute inset-0 flex items-center justify-center" data-id="element-786">
                      <span className="text-gray-500" data-id="element-787">
                        {article.title} Image
                      </span>
                    </div>
                  </div>
                  <div className="p-4" data-id="element-788">
                    <span className="text-xs text-gray-800 dark:text-gray-200 font-medium uppercase" data-id="element-789">
                      {article.category}
                    </span>
                    <h3 className="font-bold text-lg mt-1" data-id="element-790">{article.title}</h3>
                    <p className="text-sm text-gray-600 dark:text-gray-300 mt-2 line-clamp-2" data-id="element-791">
                      {article.excerpt}
                    </p>
                    <div className="flex justify-between items-center mt-3" data-id="element-792">
                      <span className="text-xs text-gray-500" data-id="element-793">
                        {article.date}
                      </span>
                      <Link to={`/blog/${article.id}`} className="text-sm text-gray-800 dark:text-gray-200 hover:underline" data-id="element-794">
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>}
        {/* Categories */}
        <div className="flex overflow-x-auto pb-2 mb-6" data-id="element-795">
          {categories.map(category => <button key={category.id} onClick={() => setActiveCategory(category.id)} className={`px-4 py-2 whitespace-nowrap mr-2 rounded-md ${activeCategory === category.id ? 'bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800' : 'bg-gray-100 dark:bg-gray-700'}`} data-id="element-796">
              {category.name}
            </button>)}
        </div>
        {/* Book Clubs Article - Featured Content */}
        <div className="mb-8 border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-797">
          <h2 className="text-xl font-bold mb-4" data-id="element-798">
            Book Clubs in Kenya: A Growing Literary Movement
          </h2>
          <div className="mb-4" data-id="element-799">
            <span className="text-xs bg-gray-200 dark:bg-gray-700 rounded-full px-2 py-1 mr-2" data-id="element-800">
              Communities
            </span>
            <span className="text-xs text-gray-500" data-id="element-801">
              October 5, 2023 • By Wanjiku Mwangi
            </span>
          </div>
          <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-802">
            Book clubs have become an integral part of Kenya's literary
            landscape, bringing together readers from all walks of life to
            discuss, debate, and discover new books. These communities foster a
            love for reading while creating spaces for meaningful social
            connections.
          </p>
          <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-803">
            From community-based reading groups to online literary communities,
            book clubs in Kenya are diverse in their focus and structure. Some
            specialize in African literature, while others explore global
            bestsellers or specific genres like fiction, non-fiction, or poetry.
          </p>
          <div className="border-l-4 border-gray-300 dark:border-gray-600 pl-4 italic mb-4" data-id="element-804">
            <p className="text-gray-600 dark:text-gray-300" data-id="element-805">
              "Book clubs provide a unique opportunity for Kenyans to engage
              with literature in a communal setting, fostering deeper
              understanding and appreciation of diverse perspectives."
            </p>
          </div>
          <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-806">
            Whether you're an avid reader or just starting your literary
            journey, joining a book club can enhance your reading experience and
            connect you with like-minded individuals who share your passion for
            books.
          </p>
          <div className="flex justify-between items-center mt-6" data-id="element-807">
            <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-808">
              This article was inspired by content from{' '}
              <a href="https://www.halfpricedbooks.co.ke/blog" target="_blank" rel="noopener noreferrer" className="underline" data-id="element-809">
                Half Priced Books
              </a>
            </span>
            <Link to="/blog/7" className="flex items-center text-gray-800 dark:text-gray-200 hover:underline" data-id="element-810">
              Read full article <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-811" />
            </Link>
          </div>
        </div>
        {/* Bookshops in Nairobi Section */}
        <div className="mb-8" data-id="element-812">
          <h2 className="text-xl font-bold mb-4 flex items-center" data-id="element-813">
            <BookIcon className="w-5 h-5 mr-2" data-id="element-814" />
            Bookshops in Nairobi
          </h2>
          <p className="text-gray-600 dark:text-gray-300 mb-6" data-id="element-815">
            Nairobi is home to a variety of bookshops catering to different
            interests and budgets. From major retailers to specialty stores,
            here's a guide to where you can find your next read.
          </p>
          <div className="space-y-4" data-id="element-816">
            {bookshops.map((shop, index) => <div key={index} className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-817">
                <h3 className="font-bold text-lg mb-1" data-id="element-818">{shop.name}</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-2" data-id="element-819">
                  {shop.description}
                </p>
                <div className="flex items-center text-xs text-gray-500 dark:text-gray-400 mb-2" data-id="element-820">
                  <MapPinIcon className="w-3 h-3 mr-1" data-id="element-821" />
                  <span data-id="element-822">{shop.location}</span>
                </div>
                {shop.website !== '#' && <a href={shop.website} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-xs text-gray-800 dark:text-gray-200 hover:underline" data-id="element-823">
                    Visit website <ExternalLinkIcon className="w-3 h-3 ml-1" data-id="element-824" />
                  </a>}
              </div>)}
          </div>
          <div className="mt-4 text-center" data-id="element-825">
            <Link to="/blog/8" className="inline-flex items-center text-gray-800 dark:text-gray-200 hover:underline" data-id="element-826">
              Read our complete guide to bookshops in Nairobi{' '}
              <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-827" />
            </Link>
          </div>
        </div>
        {/* Articles List */}
        <div className="mb-8" data-id="element-828">
          <h2 className="text-xl font-bold mb-4" data-id="element-829">
            {activeCategory === 'all' ? 'All Articles' : `${categories.find(c => c.id === activeCategory)?.name}`}
          </h2>
          {isLoading ? <div className="space-y-4" data-id="element-830">
              {[1, 2, 3].map(i => <div key={i} className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 animate-pulse" data-id="element-831">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-2" data-id="element-832"></div>
                  <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/4 mb-3" data-id="element-833"></div>
                  <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-full mb-1" data-id="element-834"></div>
                  <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-full mb-1" data-id="element-835"></div>
                  <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-2/3" data-id="element-836"></div>
                </div>)}
            </div> : <div className="space-y-4" data-id="element-837">
              {filteredArticles.map(article => <div key={article.id} className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-838">
                  <div className="flex items-center mb-2" data-id="element-839">
                    <TagIcon className="w-4 h-4 mr-1" data-id="element-840" />
                    <span className="text-xs text-gray-800 dark:text-gray-200 uppercase" data-id="element-841">
                      {article.category}
                    </span>
                  </div>
                  <h3 className="font-bold text-lg mb-2" data-id="element-842">{article.title}</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-300 mb-3" data-id="element-843">
                    {article.excerpt}
                  </p>
                  <div className="flex justify-between items-center" data-id="element-844">
                    <div className="flex items-center text-xs text-gray-500" data-id="element-845">
                      <UserIcon className="w-3 h-3 mr-1" data-id="element-846" />
                      <span data-id="element-847">{article.author}</span>
                      <span className="mx-2" data-id="element-848">•</span>
                      <CalendarIcon className="w-3 h-3 mr-1" data-id="element-849" />
                      <span data-id="element-850">{article.date}</span>
                    </div>
                    <Link to={`/blog/${article.id}`} className="text-sm flex items-center text-gray-800 dark:text-gray-200" data-id="element-851">
                      Read more <ArrowRightIcon className="w-3 h-3 ml-1" data-id="element-852" />
                    </Link>
                  </div>
                </div>)}
            </div>}
        </div>
        {/* Popular Topics */}
        <div className="mb-8" data-id="element-853">
          <h2 className="text-xl font-bold mb-4" data-id="element-854">Popular Topics</h2>
          <div className="flex flex-wrap gap-2" data-id="element-855">
            <Link to="/blog/tag/running" className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm" data-id="element-856">
              Running
            </Link>
            <Link to="/blog/tag/tech-events" className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm" data-id="element-857">
              Tech Events
            </Link>
            <Link to="/blog/tag/networking" className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm" data-id="element-858">
              Networking
            </Link>
            <Link to="/blog/tag/career-tips" className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm" data-id="element-859">
              Career Tips
            </Link>
            <Link to="/blog/tag/community-building" className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm" data-id="element-860">
              Community Building
            </Link>
            <Link to="/blog/tag/book-clubs" className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm" data-id="element-861">
              Book Clubs
            </Link>
            <Link to="/blog/tag/bookshops" className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm" data-id="element-862">
              Bookshops
            </Link>
            <Link to="/blog/tag/nairobi" className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm" data-id="element-863">
              Nairobi
            </Link>
            <Link to="/blog/tag/entrepreneurship" className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm" data-id="element-864">
              Entrepreneurship
            </Link>
            <Link to="/blog/tag/events" className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm" data-id="element-865">
              Events
            </Link>
          </div>
        </div>
        {/* Subscribe */}
        <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 text-center" data-id="element-866">
          <h2 className="text-lg font-bold mb-2" data-id="element-867">Stay Updated</h2>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-868">
            Subscribe to our newsletter to receive the latest articles, guides,
            and community updates.
          </p>
          <div className="flex max-w-md mx-auto" data-id="element-869">
            <input type="email" placeholder="Your email address" className="flex-1 p-2 border border-gray-300 dark:border-gray-600 rounded-l-md" data-id="element-870" />
            <button className="px-4 py-2 bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 rounded-r-md" data-id="element-871">
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default Blog;